const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
const apiBaseUrlExchangeRate = process.env.REACT_APP_EXCHANGE_RATE_BASE_URL;
const config = {
  apiUrl: {
    validEmail: `${apiBaseUrl}/users/validemail/v1/`,
    userSignupWithMobile: `${apiBaseUrl}/users/signup-with-mobile`,
    userSignupWithEmail: `${apiBaseUrl}/users/signup/v3/`,
    verifyOtp: `${apiBaseUrl}/users/verify-otp-login`,
    loginVerifyOtp: `${apiBaseUrl}/users/update/verify-otp`,
    updateProfile: `${apiBaseUrl}/users/profile/v1/`,
    resendOtp: `${apiBaseUrl}/users/resend-otp-login`,
    userLogin: `${apiBaseUrl}/users/login/web/v1`,
    mobileLogin: `${apiBaseUrl}/users/login-with-mobile`,
    forgotPassword: `${apiBaseUrl}/users/forgotpassword/v1/`,
    resetPassword: `${apiBaseUrl}/users/resetpassword/v1/`,
    validateOTP: `${apiBaseUrl}/users/validotp/v1/`,
    userLogout: `${apiBaseUrl}/users/logout/v1/`,
    rewardList: `${apiBaseUrl}/reward/subscription/plan`,
    activateReward: `${apiBaseUrl}/reward/subscription/user-plan/opt-in`,
    getUserPlan: `${apiBaseUrl}/reward/subscription/user-plan`,
    deactivateReward: `${apiBaseUrl}/reward/subscription/user-plan/opt-out`,
    userLogout: `${apiBaseUrl}/users/logout/v1/`,
    staticPayload: `${apiBaseUrl}/staticdata/payload/`,
    dismisscard: `${apiBaseUrl}/staticdata/dismissCard/`,
    getlinktoken: `${apiBaseUrl}/plaid/link/token/v1/`,
    plaidsuccess: `${apiBaseUrl}/plaid/additem/v1/`,
    getaddedbank: `${apiBaseUrl}/plaid/accounts/v1/`,
    cardAddToken: `${apiBaseUrl}/plaid/link/token/v1/?bankAddType=rakuten`,
    withdrawalRequest: `${apiBaseUrl}/wallet/withdrawal-request`,
    remoteConfig: `${apiBaseUrl}/staticdata/appconfig/v1/`,
    getUserProfile: `${apiBaseUrl}/users/session/v1/getUser/`,
    verifyPasswordReset: `${apiBaseUrl}/users/action-token/verify`,
    passwordReset: `${apiBaseUrl}/users/password-reset`,
    updatePhone: `${apiBaseUrl}/users/update/update-mobile`,
    verifyUpdatedOtp: `${apiBaseUrl}/users/update/verify-otp`,
    updateResendOtp: `${apiBaseUrl}/users/update/resend-otp`,
    sendMeLink: `${apiBaseUrl}/users/app-link/send`,
    mergeUsers: `${apiBaseUrl}/users/merge-users`,
    sendOtpMerge: `${apiBaseUrl}/users/send-otp-merge-users`,
    resendOtpMerge: `${apiBaseUrl}/users/resend-otp-merge-users`,
    mergeUsersLogout: `${apiBaseUrl}/users/merge-users-logout`,
    // linkToken: `${apiBaseUrl}/plaid/neo-bank/link/token/v1`,
    linkToken: `${apiBaseUrl}/plaid/neo-bank/token/v2`,
    exchangeRate: `${apiBaseUrl}/plaid/get-exchange-rates`,
    getExchangeRate: `${apiBaseUrlExchangeRate}/bank/remittance/exchange-rate`,
    reauthenticate: `${apiBaseUrl}/users/re-authenticate`,
    cricbuzzSendOtp: `${apiBaseUrl}/users/crosswalk/send-otp`,
    cricbuzzVerifyOtp: `${apiBaseUrl}/users/crosswalk/verify-otp`,
    cricbuzzResendOtp: `${apiBaseUrl}/users/crosswalk/resend-otp`,
    cricbuzzResendMsg: `${apiBaseUrl}/users/crosswalk/resend-app-link`,
    initiateRegisterPasskey: `${apiBaseUrl}/users/passkeys/initiate-register`,
    completeRegisterPasskey: `${apiBaseUrl}/users/passkeys/register/finish`,
    initiatePasskeyLogin: `${apiBaseUrl}/users/passkeys/initiate-auth`,
    completePasskeyLogin: `${apiBaseUrl}/users/passkeys/login`,
    registeredPassKeys: `${apiBaseUrl}/users/passkeys/details`,
  },
  rakutenUrl: process.env.REACT_APP_RAKUTEN_IFRAME_URL,
  signupSliderItems: [
    {
      url: "https://staticimages.timesclub.co/Website+images/New+Home+Page/Signup+Page/Card1.png",
      source: ["web"],
    },
    {
      url: "https://staticimages.timesclub.co/Website+images/New+Home+Page/Signup+Page/Card2.png",
      source: ["web"],
    },
    {
      url: "https://timesclub-static.s3.us-east-2.amazonaws.com/Website+images/New+Home+Page/Signup+Page/Instacart.jpg",
      source: ["web"],
    },
    {
      url: "https://timesclub-static.s3.us-east-2.amazonaws.com/Website+images/New+Home+Page/Signup+Page/DEsney.jpg",
      source: ["web"],
    },
    // {
    //   url: "https://timesclub-static.s3.us-east-2.amazonaws.com/Website+images/New+Home+Page/Signup+Page/Quickly.jpg",
    //   source: ["web"],
    // },
    {
      url: "https://timesclub-static.s3.us-east-2.amazonaws.com/Website+images/New+Home+Page/Signup+Page/Remittance_0.jpg",
      source: ["remittance"],
      sliderImageCls: "remittanceImg",
    },
    {
      url: "https://timesclub-static.s3.us-east-2.amazonaws.com/Website+images/New+Home+Page/Signup+Page/Remittance_1.jpg",
      source: ["remittance"],
      sliderImageCls: "remittanceImg",
    },
    {
      url: "https://timesclub-static.s3.us-east-2.amazonaws.com/Website+images/New+Home+Page/Signup+Page/Remittance_2.jpg",
      source: ["remittance"],
      sliderImageCls: "remittanceImg",
    },
    {
      url: "https://timesclub-static.s3.us-east-2.amazonaws.com/Website+images/New+Home+Page/Signup+Page/Remittance_3.jpg",
      source: ["remittance"],
      sliderImageCls: "remittanceImg",
    },
    {
      url: "https://timesclub-static.s3.us-east-2.amazonaws.com/Website+images/New+Home+Page/Signup+Page/Remittance_4.jpg",
      source: ["remittance"],
      sliderImageCls: "remittanceImg",
    },
    {
      url: "https://timesclub-static.s3.us-east-2.amazonaws.com/Website+images/New+Home+Page/Signup+Page/Remittance_5.jpg",
      source: ["remittance"],
      sliderImageCls: "remittanceImg",
    },
  ],
  sdkAll: "ALL",
};

export default config;
